import React from 'react';
import {
  Box, Grid, IconButton, Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ReactComponent as Trash } from 'images/icons/trash.svg';
import NumberFormatContext from 'components/CustomInputsInFormikContext/NumberFormat';
import TextFieldContext from 'components/CustomInputsInFormikContext/TextField';
import AutoCompleteContext from 'components/CustomInputsInFormikContext/AutoComplete';
import { useParams } from 'react-router-dom';
import { labelField } from 'utils';

function InputGroup({
  index, onRemove, onAdd, species,
}) {
  const { id } = useParams();
  const disabledField = id;

  return (
    <Box display="flex" width="100%" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={2.4}>
          <TextFieldContext
            disabled={disabledField}
            label={labelField('Nome')}
            name={`lots.${index}.name`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2.4}>
          <AutoCompleteContext
            disabled={disabledField}
            label={labelField('Espécie')}
            name={`lots.${index}.specie`}
            options={species}
            getOptionLabel={(option) => `${option.name}`}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={2.4}>
          <NumberFormatContext
            disabled={disabledField}
            fieldSize={20}
            label={labelField('Qtde de Animais')}
            name={`lots.${index}.size`}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={2.4}>
          <NumberFormatContext
            disabled={disabledField}
            fieldSize={20}
            label={labelField('Idade')}
            name={`lots.${index}.old`}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={2.4}>
          <NumberFormatContext
            disabled={disabledField}
            fieldSize={20}
            label={labelField('Preço Total')}
            name={`lots.${index}.price`}
            prefix="R$ "
            decimalScale={2}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs="auto"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        {index > 0 && (
          <Tooltip title="Remover">
            <IconButton
              disabled={disabledField}
              sx={{ bgcolor: '#FFDAD6' }}
              size="large"
              onClick={onRemove}
            >
              <Trash style={{ width: 14, height: 14, color: '#B3261E' }} />
            </IconButton>
          </Tooltip>
        )}

        {index === 0 && (
          <Tooltip title="Adicionar">
            <IconButton
              disabled={disabledField}
              sx={{ bgcolor: '#DBE5DE' }}
              onClick={onAdd}
            >
              <AddIcon sx={{ color: '#006E2D' }} />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Box>
  );
}

export default InputGroup;
